import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const track = async () => {
      try {
        await fetch(`${BACKEND_URL}/api/analytics/pageview`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer || null,
            screen_width: window.innerWidth,
          }),
        });
      } catch (e) {
        // silently fail
      }
    };
    track();
  }, [location.pathname]);

  return null;
};

export default PageTracker;
